export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_3.b863959f.png";